module.exports = __webpack_public_path__ + "img/strength-1.39cede30.png";